export enum AssetType {
  Grid = 'GRID_CONNECTION',
  Bess = 'BESS',
  DistributionComponent = 'DISTRIBUTION_COMPONENT',
  Evse = 'EVSE',
  ChargingStation = 'CHARGING_STATION',
  DepotLoad = 'DEPOT_LOAD',
  Pv = 'PV',
  ElectricVehicle = 'ELECTRIC_VEHICLE',
  Losses = 'LOSSES',
}

// TODO ask Alexy wether or not he wants to order assets in a specific way (charger / evse/vehicle ABC order?)
// Among infrastructure ? asset type enum order?
